<div class="transaction-table-container">
  <!-- Empty State -->
  @if (transactions.length === 0) {
    <div class="empty-state">
      <ion-icon name="receipt-outline" color="medium"></ion-icon>
      <p>No transactions found</p>
    </div>
  }

  <!-- Table -->
  @if (transactions.length > 0) {
    <div class="table-wrapper">
      <table class="transaction-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th>Type</th>
            <th class="amount-column">Amount</th>
          </tr>
        </thead>
        <tbody>
          @for (transaction of transactions; track transaction) {
            <tr>
              <td class="date-column">
                {{ transaction.createdAt | date: "short" }}
              </td>
              <td class="description-column">
                {{ transaction.description || "N/A" }}
              </td>
              <td class="type-column">
                <div class="type-cell">
                  <ion-icon
                    [name]="getTransactionIcon(transaction)"
                  [color]="getTransactionColor(transaction)"></ion-icon>
                  <ion-chip [color]="getTransactionColor(transaction)" class="type-badge">
                    {{ transaction.type }}
                  </ion-chip>
                </div>
              </td>
              <td class="amount-column" [ngClass]="transaction.isPositive ? 'positive' : 'negative'">
                {{ transaction.formattedAmount }}
              </td>
            </tr>
          }
        </tbody>
      </table>
      <!-- Pagination -->
      <div class="pagination-controls">
        <ion-button
          fill="clear"
          size="small"
          [disabled]="!hasPreviousPage"
          (click)="previousPage()">
          <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
        </ion-button>
        <span class="page-info">
          Page {{ currentPage + 1 }} of {{ Math.ceil(totalTransactions / maxTransactions) || 1 }}
          ({{ totalTransactions }} total)
        </span>
        <ion-button
          fill="clear"
          size="small"
          [disabled]="!hasNextPage"
          (click)="nextPage()">
          <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
        </ion-button>
      </div>
    </div>
  }
</div>
